function Projects() {
  return (
    <div className="projects-section">
      <h1>Our Installations</h1>

      <div className="projects-container">

        <div className="project-card">
          <img src="\customer1 (1).jpeg" />
          <div className="project-info">
            <h3>5kW Solar System</h3>
            <p>📍 Jhansi</p>
          </div>
        </div>

        <div className="project-card">
          <img src="\customer2.jpeg" />
          <div className="project-info">
            <h3>5kW Solar System</h3>
            <p>📍 Jhansi</p>
          </div>
        </div>

        <div className="project-card">
          <img src="\customer3.jpeg" />
          <div className="project-info">
            <h3>3kW Solar System</h3>
            <p>📍 Jhansi</p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Projects;